// extracted by mini-css-extract-plugin
module.exports = {"avatarBorder":"Avatar_avatarBorder__3k0sf","avatar":"Avatar_avatar__2OXA9"};